// The tool someone used last in this browser, so signing in again opens it. Login
// with no destination used to land an English-locale account on the marketing home,
// and many Spanish-browser users have the site in English: in two weeks, 4 of the 15
// signed-in Spanish-browser sessions that started there never reached the app
// (PostHog, 2026-09-30).
const KEY = 'cs_last_tool';
const TOOLS = ['/ai-agent', '/ai-clipping', '/auto-caption', '/reframe', '/editor'];

const toolOf = (pathname) => TOOLS.find((tool) => pathname === tool || pathname.startsWith(`${tool}/`)) || null;

/** Note the tool this page belongs to, if it is one. */
export function rememberTool(pathname) {
  const tool = toolOf(pathname || '');
  if (!tool) return;
  try { window.localStorage.setItem(KEY, tool); } catch { /* signing in lands on the default */ }
}

/** The last tool used here, or null. Only ever one of the tools' own pages. */
export function lastTool() {
  try {
    const kept = window.localStorage.getItem(KEY);
    return TOOLS.includes(kept) ? kept : null;
  } catch {
    return null;
  }
}

/**
 * Where a sign-in with no destination lands: the tool used last; else the AI Agent
 * for anyone reading the site, or using a browser, in another language than English
 * (that is what their pages sell); else home, as English readers always have.
 */
export function afterSignIn(locale, languages = (typeof navigator !== 'undefined' ? navigator.languages || [navigator.language] : []), { newAccount = false } = {}) {
  // An account made just now (Google on the login page makes one for someone new) lands
  // where a sign-up does: the AI Agent, not the English home. Of 13 new accounts in two
  // weeks that landed on the home page, 8 made something; of 185 sent to the AI Agent, 158
  // (PostHog, 2026-10-02)
  if (newAccount) return lastTool() || '/ai-agent';
  const english = locale === 'en' && (languages || []).every((tag) => !tag || String(tag).toLowerCase().startsWith('en'));
  return lastTool() || (english ? '/' : '/ai-agent');
}

/** Whether a Clerk user was made in the last ten minutes, by this sign-in. */
export const madeJustNow = (createdAt, now = Date.now()) => {
  const at = createdAt ? new Date(createdAt).getTime() : NaN;
  return Number.isFinite(at) && now - at >= 0 && now - at < 10 * 60 * 1000;
};
